import { Component, Injectable, Input, OnInit } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCommissionCalendarModel } from 'src/oldApp/model/cat-commission-calendar.model';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatCommissionCalendarService } from 'src/oldApp/services/cat-commission-calendar.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';

//////////////////////
// Traducir datepicker
const I18N_VALUES={
  es:{
    weekdays:['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
    months:['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  }
};

@Injectable()
export class I18n { language='es'; }
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private _i18n:I18n) {
    super();
  }

  getDayAriaLabel(date:NgbDateStruct) {
    return '';
  }
  getWeekdayShortName(weekday:number):string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday-1];
  }
  getMonthShortName(month:number):string {
    return I18N_VALUES[this._i18n.language].months[month-1];
  }
  getMonthFullName(month:number):string {
    return this.getMonthShortName(month);
  }
}
//////////////////////

@Component({
  selector: 'app-modal-commission-calendar',
  templateUrl: './modal-commission-calendar.component.html',
  styleUrls: ['./modal-commission-calendar.component.css'],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})
export class ModalCommissionCalendarComponent implements OnInit {
  @Input() calendar:CatCommissionCalendarModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus=0;
  public date=null;

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[];
  public payGroupCatalog:any[]=[
    {id:0, description:'Grupo 0'},
    {id:1, description:'Grupo 1'},
    {id:2, description:'Grupo 2'},
    {id:3, description:'Grupo 3'},
    {id:4, description:'Grupo 4'},
    {id:5, description:'Grupo 5'},
  ];

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  ////////////////
  constructor(
    private modalService: NgbModal,
    private calendarService:CatCommissionCalendarService,
    private catEmployeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    if(this.calendar.date) {
      let date=this.calendar.date.split(' ')[0];
      this.date={year:Number(date.split('-')[0]), month:Number(date.split('-')[1]), day:Number(date.split('-')[2])};
    }
    this.getCatalogs();
  }

  //
  selectedDate=e=> {
    this.date=e;
    this.calendar.date=e.year+'-'+('0'+e.month).slice(-2)+'-'+('0'+e.day).slice(-2)
    this.calendar.year=e.year;
    this.calendar.month=e.month;
  }
  toggleActive=()=> this.calendar.activeId=!this.calendar.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.dateError()) errors.push('Necesita seleccionar una fecha.');
    if(this.payGroupError()) errors.push('Necesita seleccionar un grupo de pago.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.calendarService.save(this.calendar)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('el calendario se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar el calendario.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  employeeJobError=()=> !this.calendar.employeeJobId;
  dateError=()=> !this.date;
  payGroupError=()=> this.calendar.payGroup!==0 && !this.calendar.payGroup;

  // INFO
  getCatalogs=()=> {
    this.catEmployeeJobService.getAll()
      .pipe(
        tap((resp:any)=> {
          this.employeeJobCatalog=resp;
          this.viewStatus=1;
        }),
        catchError(error=> {
          console.log(error);
          this.close();
          return of(this.toastr.error('Ocurrió un error al leer los catálogos'));
        })
      )
      .subscribe();
  }
}
